module.exports = __webpack_public_path__ + "img/bandeau_merci.2f681c34.png";